import { Link } from "react-router-dom";
import { categoryLinks } from "@/mocks/categories";

export default function Footer() {
  const firstHalf = categoryLinks.slice(0, 7);
  const secondHalf = categoryLinks.slice(7);

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left: Brand + Newsletter */}
          <div className="lg:w-2/5">
            <Link to="/" className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-leaf-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-heading text-foreground-900">VigorBuy</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-sm">
              Your go-to resource hub for the VigorBuy Spreadsheet. Discover curated product
              lists, buying guides, and shopping resources updated weekly.
            </p>
            <div>
              <p className="text-xs font-medium text-foreground-500 mb-2 uppercase tracking-wide">
                Subscribe for updates
              </p>
              <form
                data-readdy-form=""
                className="flex flex-col sm:flex-row gap-2"
                onSubmit={(e) => {
                  e.preventDefault();
                  const target = e.target as HTMLFormElement;
                  const formData = new FormData(target);
                  const honeypot = (formData.get("website_alt") as string || "").trim();
                  if (honeypot) {
                    const msg = document.getElementById("footer-newsletter-msg");
                    if (msg) { msg.textContent = "Thanks for subscribing!"; msg.className = "text-xs text-primary-600 mt-2"; }
                    target.reset();
                    return;
                  }
                  const body = new URLSearchParams();
                  body.append("email", formData.get("email") as string || "");
                  fetch("https://readdy.ai/api/form/d90jco6s51g94qljs730", {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: body.toString(),
                  })
                    .then(() => {
                      const msg = document.getElementById("footer-newsletter-msg");
                      if (msg) { msg.textContent = "Thanks for subscribing!"; msg.className = "text-xs text-primary-600 mt-2"; }
                      target.reset();
                    })
                    .catch(() => {
                      const msg = document.getElementById("footer-newsletter-msg");
                      if (msg) { msg.textContent = "Something went wrong. Please try again."; msg.className = "text-xs text-secondary-500 mt-2"; }
                    });
                }}
              >
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your email address"
                  className="flex-1 px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors duration-200"
                  required
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Join Newsletter
                </button>
              </form>
              <p id="footer-newsletter-msg" className="text-xs text-foreground-500 mt-2"></p>
            </div>
          </div>

          {/* Right: Link Columns */}
          <div className="lg:w-3/5 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {/* Quick Links */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                Quick Links
              </h4>
              <div className="flex flex-col gap-2.5">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  VigorBuy Sheet
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Buy It Now
                </a>
                <Link
                  to="/article/vigorbuy-spreadsheet-guide"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
                >
                  Beginner Guide
                </Link>
                <Link
                  to="/article/vigorbuy-spreadsheet-safety"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
                >
                  Safety Guide
                </Link>
                <Link
                  to="/article/vigorbuy-spreadsheet-shopping-list"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
                >
                  Shopping Guide
                </Link>
              </div>
            </div>

            {/* Categories 1 */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                Categories
              </h4>
              <div className="flex flex-col gap-2.5">
                {firstHalf.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Categories 2 */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                More Categories
              </h4>
              <div className="flex flex-col gap-2.5">
                {secondHalf.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} VigorBuy Resource Hub. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            This is an independent resource guide. All product links direct to the main store.
          </p>
        </div>
      </div>
    </footer>
  );
}